import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsButton, BsCard, BsForm, BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiForm, apiGet } from '../../utils/api';
import { appendArrayToFormData } from '../../utils/functions';
import InputEstado from '../project/InputEstado';

/**
 * Filtro para calendario.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 * - selectFechas, selectDepartamento, selectTrabajador, selectEstado: Si se incluyen estas propiedades, el filtro incluirá los respectivos campos.
 */
export default function CalendarFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => {
        if (!data.get("departamentos[]"))
            data.delete("departamentos[]");
        await onFilter(data);
    }

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <CalendarFilterForm
            defaultValue={defaultValue}
            {...otherProps} />
    </BsForm>;
}

class CalendarFilterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listDepartamentos: null,
            listTrabajadores: null,
            refreshKey: Math.random(),
            refreshKeyTrabajadores: Math.random(),
        };
        this.refresh = this.refresh.bind(this);
        this.handleDepartamentoChange = this.handleDepartamentoChange.bind(this);
    }

    componentDidMount() {
        this.updateDepartamentos();
        this.updateTrabajadores(this.props.data.departamento);
    }

    refresh() {
        this.updateTrabajadores(this.props.defaultValue.departamento);
        this.setState({ refreshKey: Math.random() });
    }

    handleDepartamentoChange(element) {
        this.updateTrabajadores(element.map(d => d.value));
    }

    async updateDepartamentos() {
        if (this.props.selectDepartamento) {
            this.setState({ listDepartamentos: await apiGet("departamentos/calendarList") });
        }
    }

    async updateTrabajadores(departamentos) {
        if (this.props.selectTrabajador) {
            let trabajadores;
            if (departamentos && departamentos.length > 0) {
                const formData = new FormData;
                appendArrayToFormData(formData, "departamentos", departamentos);
                trabajadores = await apiForm("usuarios/calendarList", formData);
            } else {
                trabajadores = await apiGet("usuarios/calendarList");
            }
            this.setState({
                listTrabajadores: trabajadores,
                refreshKeyTrabajadores: Math.random()
            });
        }
    }

    render() {
        const data = this.props.data;
        const ready =
            (!this.props.selectDepartamento || this.state.listDepartamentos) &&
            (!this.props.selectTrabajador || this.state.listTrabajadores);
        return (
            <BsCard header="Filtro" className={this.props.className} collapsed>
                {ready ? <>
                    <Row className="gy-3" key={this.state.refreshKey}>
                        {/* Usuarios */}
                        {this.props.selectDepartamento &&
                            <Col md="6">
                                <BsFormSelect
                                    /* Departamento */
                                    label="Departamento" name="departamentos[]"
                                    value={data.departamento}
                                    options={this.state.listDepartamentos}
                                    onChange={this.handleDepartamentoChange}
                                    isClearable isMulti />
                            </Col>
                        }
                        {this.props.selectTrabajador ?
                            <Col md="6">
                                <BsFormSelect
                                    /* Trabajador */
                                    label="Trabajador" name="trabajador"
                                    value={data.trabajador}
                                    options={this.state.listTrabajadores}
                                    key={this.state.refreshKeyTrabajadores}
                                    isClearable />
                            </Col> :
                            <HiddenInput name="trabajador" value={data.trabajador} />}
                        {/* Estado */}
                        {this.props.selectEstado ?
                            <Col md="6">
                                <InputEstado pendiente={data.pendiente} validado={data.validado} />
                            </Col>
                            :
                            <>
                                <HiddenInput name="pendiente" value={data.pendiente} />
                                <HiddenInput name="validado" value={data.validado} />
                            </>
                        }
                    </Row>
                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <BsButton onClick={this.props.onSubmit}>Mostrar resultados</BsButton>
                        <BsButton variant="secondary" onClick={this.refresh}>Reestablecer</BsButton>
                    </div>
                </> : <Loading className="text-center" />}
            </BsCard>
        );
    }
}
